"use client";

import { Search } from 'lucide-react';
import Link from 'next/link';

export function Header() {
  return (
    <header className="fixed top-0 z-50 w-full backdrop-blur-sm" style={{ 
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      borderBottom: '1px solid var(--stone)'
    }}>
      <nav className="mx-auto max-w-screen-2xl px-8 lg:px-16">
        <div className="flex h-20 items-center justify-between">
          {/* Logo - Minimal */}
          <Link href="/" className="flex items-center gap-3 group">
            <span style={{ 
              fontFamily: 'var(--font-display)',
              fontSize: 'var(--text-xl)',
              fontWeight: 400,
              color: 'var(--charcoal)',
              letterSpacing: '-0.02em'
            }}>
              Israeli Wine
            </span>
          </Link>

          {/* Desktop Navigation - Minimal */}
          <div className="hidden lg:flex lg:items-center lg:gap-12">
            <Link 
              href="/education" 
              className="transition-opacity duration-200 hover:opacity-50"
              style={{ 
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-sm)',
                fontWeight: 400,
                color: 'var(--charcoal)',
                letterSpacing: '0.01em'
              }}
            >
              Education
            </Link>
            <Link 
              href="/directory" 
              className="transition-opacity duration-200 hover:opacity-50"
              style={{ 
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-sm)',
                fontWeight: 400,
                color: 'var(--charcoal)',
                letterSpacing: '0.01em'
              }}
            >
              Directory
            </Link>
            <Link 
              href="/tours" 
              className="transition-opacity duration-200 hover:opacity-50"
              style={{ 
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-sm)',
                fontWeight: 400,
                color: 'var(--charcoal)',
                letterSpacing: '0.01em'
              }}
            >
              Tours
            </Link>
            <Link 
              href="/community" 
              className="transition-opacity duration-200 hover:opacity-50"
              style={{ 
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-sm)',
                fontWeight: 400,
                color: 'var(--charcoal)',
                letterSpacing: '0.01em'
              }}
            >
              Community
            </Link>
          </div>

          {/* Search Button - Ultra minimal */}
          <button 
            className="flex items-center gap-2 px-4 py-2 transition-colors duration-200"
            style={{ 
              backgroundColor: 'var(--charcoal)',
              color: 'var(--paper)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--slate)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--charcoal)';
            }}
          >
            <Search size={16} />
            <span className="hidden sm:inline" style={{ 
              fontFamily: 'var(--font-body)',
              fontSize: 'var(--text-sm)',
              fontWeight: 400,
              letterSpacing: '0.01em'
            }}>
              Search
            </span>
          </button>
        </div>
      </nav>
    </header>
  );
}